import colors from 'themes/Main';

const { darkBlue, gray05 } = colors;

export const styledScroll = `
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: ${darkBlue} ${gray05};
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: ${gray05};
  }

  ::-webkit-scrollbar:vertical {
    width: 6px;
  }

  ::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-appearance: none;
    background-color: ${darkBlue};
    border-radius: 0px;
    border:none;
  }

  ::-webkit-scrollbar-track {
    -webkit-appearance: none;
    border-radius: 0px;
    background-color: transparent;
  }
`;
